// Centralised axios calls for the Sales Funnel / Leads CRM module.
// Pattern mirrors api_calls.js (reseller context): async/await Promise wrapper,
// getAccount() + getToken(), same CORS headers as every other working module.
import axios from "axios";

const BASE = process.env.REACT_APP_API_URL + "admin_leads/";

async function post(accountno, token, endpoint, payload) {
  return await new Promise((resolve, reject) => {
    try {
      axios
        .post(
          BASE + endpoint,
          JSON.stringify({
            token: process.env.REACT_APP_API_TOKEN,
            api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
            accountno: accountno,
            ...(payload || {}),
          }),
          {
            headers: {
              Authorization: `bearer ${token}`,
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "http://localhost:3000",
              "Access-Control-Allow-Credentials": true,
              useCredentails: true,
            },
          }
        )
        .then((response) => {
          resolve(response);
        });
    } catch (error) {
      console.log("catch : ", error);
    }
  });
}

// ---- Stages ---------------------------------------------------------
export const listStages       = (acc, tok)            => post(acc, tok, "list_stages");
export const saveStages       = (acc, tok, stages, opts) => post(acc, tok, "save_stages",  { stages, silent: opts && opts.silent ? 1 : 0 });
export const addStage         = (acc, tok, payload)   => post(acc, tok, "add_stage",    payload);
export const removeStage      = (acc, tok, stage_key) => post(acc, tok, "remove_stage", { stage_key });

// ---- Lookups --------------------------------------------------------
export const listPartners         = (acc, tok)                        => post(acc, tok, "list_partners");
export const listPartnerProducts  = (acc, tok, partner_accountno)     => post(acc, tok, "list_partner_products", { partner_accountno });

// ---- Lead CRUD -------------------------------------------------------
export const createLead   = (acc, tok, payload) => post(acc, tok, "create_lead",  payload);
export const updateLead   = (acc, tok, payload) => post(acc, tok, "update_lead",  payload);
export const getLead      = (acc, tok, lead_id) => post(acc, tok, "get_lead",     { lead_id });
export const archiveLead  = (acc, tok, lead_id) => post(acc, tok, "archive_lead", { lead_id });
export const restoreLead  = (acc, tok, lead_id) => post(acc, tok, "restore_lead", { lead_id });

// ---- Lists & Stage moves --------------------------------------------
export const listLeadsGrid   = (acc, tok, filters) => post(acc, tok, "list_leads_grid",   filters || {});
export const listLeadsKanban = (acc, tok, filters) => post(acc, tok, "list_leads_kanban", filters || {});
export const updateStage     = (acc, tok, payload) => post(acc, tok, "update_stage",      payload);

// ---- Activities feed ------------------------------------------------
export const listActivities  = (acc, tok, filters) => post(acc, tok, "list_activities",   filters || {});

// ---- Metrics --------------------------------------------------------
export const getPipelineKpis  = (acc, tok, filters) => post(acc, tok, "get_pipeline_kpis",  filters || {});
export const getFunnelMetrics = (acc, tok, filters) => post(acc, tok, "get_funnel_metrics", filters || {});
export const getBreakdowns    = (acc, tok, filters) => post(acc, tok, "get_breakdowns",     filters || {});

// ---- Notes (Lead Detail Phase 1) ------------------------------------
export const listNotes   = (acc, tok, payload) => post(acc, tok, "list_notes",   payload || {});
export const addNote     = (acc, tok, payload) => post(acc, tok, "add_note",     payload || {});
export const updateNote  = (acc, tok, payload) => post(acc, tok, "update_note",  payload || {});
export const deleteNote  = (acc, tok, note_id) => post(acc, tok, "delete_note",  { note_id });

// ---- Lead score engine ----------------------------------------------
export const getScoreWeights  = (acc, tok)            => post(acc, tok, "get_score_weights");
export const saveScoreWeights = (acc, tok, payload)   => post(acc, tok, "save_score_weights", payload || {});
export const recalcLeadScore  = (acc, tok, lead_id)   => post(acc, tok, "recalc_lead_score",  { lead_id });

// ---- @mention picker source -----------------------------------------
export const listTeamMembers  = (acc, tok)            => post(acc, tok, "list_team_members");

// ---- Bulk Import Leads -----------------------------------------------
export const bulkImportPreview = (acc, tok, file) => {
  const formData = new FormData();
  formData.append("token", process.env.REACT_APP_API_TOKEN);
  formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
  formData.append("accountno", acc);
  formData.append("file", file);
  
  return axios.post(BASE + "bulk_import_preview", formData, {
    headers: {
      Authorization: `bearer ${tok}`,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const bulkImportExecute = (acc, tok, leads) => {
  return post(acc, tok, "bulk_import_execute", { leads });
};

export const downloadBulkImportSample = (acc, tok) => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .post(
          BASE + "bulk_import_sample",
          JSON.stringify({
            token: process.env.REACT_APP_API_TOKEN,
            api_accountno: process.env.REACT_APP_API_ACCOUNTNO,
            accountno: acc,
          }),
          {
            headers: {
              Authorization: `bearer ${tok}`,
              "Content-Type": "application/json;charset=UTF-8",
            },
            responseType: "blob",
          }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    } catch (error) {
      console.log("catch : ", error);
      reject(error);
    }
  });
};